import { useMemo, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { mayaCustomerInitiativeListRoute } from 'basics/constants/routes.constants';
import { succesToast, warningToast } from 'basics/utils/toast';
import {
  CiFormCanceltCallbackType,
  CiFormSubmitCallbackType,
} from 'modules/maya/components/CustomerInitiativeForm/CustomerInitiativeForm.types';
import { useUpdateCustomerInitiativeMutation } from 'modules/maya/graphql/mutations/updateCustomerInitiative';
import useGetCustomerInitiativeByIdQuery from 'modules/maya/graphql/queries/getCustomerInitiativeById';

const useCustomerInitiativeEdit = () => {
  const navigate = useNavigate();

  const [updateCustomerInitiative] = useUpdateCustomerInitiativeMutation();

  const urlParams = useMemo(() => new URLSearchParams(window.location.search), []);

  const location = useLocation();
  const currentURL = location.pathname;

  const [loading, setLoading] = useState(true);

  const customerInitiative = useGetCustomerInitiativeByIdQuery(urlParams.get('id')).data;

  useEffect(() => {
    if (customerInitiative) {
      setLoading(false);
    }
  }, [customerInitiative, setLoading]);

  const handleCancelCustomerInitiativeForm: CiFormCanceltCallbackType = () => {
    navigate(mayaCustomerInitiativeListRoute);
  };

  const handleSaveCustomerInitiativeForm: CiFormSubmitCallbackType = async (ci) => {
    const customerInitiativeData = await updateCustomerInitiative(customerInitiative?._id || null, { ...ci, isTemplate: false });

    if (customerInitiativeData) {
      succesToast(`Customer initiative ${ci.title} updated`);
      navigate(mayaCustomerInitiativeListRoute);
    } else {
      warningToast(`Cannot update customer initiative ${ci.title}`);
    }
  };

  return {
    loading,
    customerInitiative,
    currentURL,
    handleSaveCustomerInitiativeForm,
    handleCancelCustomerInitiativeForm,
  };
};

export default useCustomerInitiativeEdit;
